import React, { useState } from 'react';
import AvatarEditor from 'react-avatar-editor';
import { Button, ButtonToolbar, Row } from 'angieslist-react-components';
import { Track } from 'angieslist-app-platform';
import Loader from 'angieslist-app-platform/lib/browser/Loader';

type Props = {
  mediaId: any,
  url: any,
  setImageEditorRef: any,
  imageCanvasLoading: boolean,
  setImageCanvasLoading: Function,
  rotationEnabled: boolean, // Delete this prop when photos have the edit photo enabled
};

const ImageEditor = ({
  mediaId,
  url,
  setImageEditorRef,
  imageCanvasLoading,
  setImageCanvasLoading,
  rotationEnabled,
}: Props) => {
  const [rotate, setRotate] = useState(0);

  const rotateImage = (e) => {
    e.preventDefault();
    const buttonClicked = e.target.id;
    const wouldHaveOriginalOrientation = rotate === 270 || rotate === -270;
    if (wouldHaveOriginalOrientation) { setRotate(0); }
    if (!wouldHaveOriginalOrientation && buttonClicked === 'Edit-Image-Modal--Left') { setRotate(rotate - 90); }
    if (!wouldHaveOriginalOrientation && buttonClicked === 'Edit-Image-Modal--Right') { setRotate(rotate + 90); }
  };

  return (
    <div id="Image-Editor--Container">

      <AvatarEditor
        key={`editor-${mediaId}`}
        image={url}
        className="img-thumbnail img-responsive"
        style={{ margin: 'auto' }}
        crossOrigin="anonymous"
        rotate={parseFloat(rotate)}
        height={180}
        border={0}
        ref={setImageEditorRef}
        onImageReady={() => {
          setImageCanvasLoading(false);
        }}
      />

      <Loader
        loading={imageCanvasLoading}
        element={
          <Row className="category-row text-center" style={{ marginTop: '1em' }}>
            <i className="icon icon-load icon-spin icon-3x text-primary" />
          </Row>
        }
      >
        <If condition={rotationEnabled}>
          <ButtonToolbar className="text-center" style={{ marginTop: '1em' }} key={`button-toolbar-${mediaId}`}>
            <Track>
              <Button
                id="Edit-Image-Modal--Left"
                bsSize="xsmall"
                bsStyle="default-office"
                onClick={rotateImage}
              >
                <i className="icon icon-ccw" /> Rotate Left
              </Button>
            </Track>
            <Track>
              <Button
                id="Edit-Image-Modal--Right"
                bsSize="xsmall"
                bsStyle="default-office"
                onClick={rotateImage}
              >
                <i className="icon icon-ccw icon-flip-horizontal" /> Rotate Right
              </Button>
            </Track>
          </ButtonToolbar>
        </If>
      </Loader>
    </div>
  );
};

export default(ImageEditor);



// WEBPACK FOOTER //
// ./src/modules/showcase/browser/components/ImageEditor.js